import { noop, combine, toServerDuration, generateUUID, SKIPPED } from '@datadog/browser-core';
import { discardNegativeDuration } from '../discardNegativeDuration';
import { ActionType, RumEventType } from '../../rawRumEvent.types';
import { trackClickActions } from './trackClickActions';
export function startActionCollection(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration) {
  var _lifeCycle$subscribe = lifeCycle.subscribe(0
  /* LifeCycleEventType.AUTO_ACTION_COMPLETED */
  , function (action) {
    lifeCycle.notify(12
    /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */
    , processAction(action));
  }),
      unsubscribeAutoAction = _lifeCycle$subscribe.unsubscribe;

  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var startTime = _ref.startTime,
        eventType = _ref.eventType;

    if (eventType !== RumEventType.ERROR && eventType !== RumEventType.RESOURCE && eventType !== RumEventType.LONG_TASK) {
      return SKIPPED;
    }

    var actionId = actionContexts.findActionId(startTime);

    if (!actionId) {
      return SKIPPED;
    }

    return {
      type: eventType,
      action: {
        id: actionId
      }
    };
  });
  hooks.register(1
  /* HookNames.AssembleTelemetry */
  , function (_ref2) {
    var startTime = _ref2.startTime;
    return {
      action: {
        id: actionContexts.findActionId(startTime)
      }
    };
  });
  var actionContexts = {
    findActionId: noop
  };
  var _stop = noop;

  if (configuration.trackUserInteractions) {
    ;

    var _trackClickActions = trackClickActions(lifeCycle, domMutationObservable, windowOpenObservable, configuration);

    actionContexts = _trackClickActions.actionContexts;
    _stop = _trackClickActions.stop;
  }

  return {
    addAction: function addAction(action) {
      lifeCycle.notify(12
      /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */
      , processAction(action));
    },
    actionContexts: actionContexts,
    stop: function stop() {
      unsubscribeAutoAction();

      _stop();
    }
  };
}

function processAction(action) {
  var autoActionProperties = isAutoAction(action) ? {
    action: {
      id: action.id,
      loading_time: discardNegativeDuration(toServerDuration(action.duration)),
      frustration: {
        type: action.frustrationTypes
      },
      error: {
        count: action.counts.errorCount
      },
      long_task: {
        count: action.counts.longTaskCount
      },
      resource: {
        count: action.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: action.target,
        position: action.position,
        name_source: action.nameSource
      }
    }
  } : {
    context: action.context
  };
  var actionEvent = combine({
    action: {
      id: generateUUID(),
      target: {
        name: action.name
      },
      type: action.type
    },
    date: action.startClocks.timeStamp,
    type: RumEventType.ACTION
  }, autoActionProperties);
  var duration = isAutoAction(action) ? action.duration : undefined;
  var domainContext = isAutoAction(action) ? {
    events: action.events
  } : {
    handlingStack: action.handlingStack
  };
  return {
    rawRumEvent: actionEvent,
    duration: duration,
    startTime: action.startClocks.relative,
    domainContext: domainContext
  };
}

function isAutoAction(action) {
  return action.type !== ActionType.CUSTOM;
}